export default __webpack_public_path__ + "static/media/Debabrata Sarkar.79dcca72.jpg";